// extracted by mini-css-extract-plugin
module.exports = {"methods":"ServiceActivationPaymentMethods_methods__3cpUj","method":"ServiceActivationPaymentMethods_method__CZbO6","submitBtn":"ServiceActivationPaymentMethods_submitBtn__EaArD"};